module.exports = __webpack_public_path__ + "static/media/9.03c55f85.jpg";